export default __webpack_public_path__ + "static/media/Forsters Financial Dark.eb43a82e.svg";